import React, { useState, useEffect } from 'react';
import {
  Snackbar,
  Alert,
  Button,
  Box,
  Typography,
} from '@mui/material';
import {
  Refresh,
  Update,
} from '@mui/icons-material';
import { serviceWorkerManager } from '../../utils/pwa';

const UpdateNotification: React.FC = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    const unsubscribe = serviceWorkerManager.onUpdateAvailable(() => {
      setUpdateAvailable(true);
    });

    return unsubscribe;
  }, []);

  const handleUpdate = () => {
    setUpdating(true);
    serviceWorkerManager.skipWaiting();
    // The page will reload automatically when the new service worker takes control
  };

  const handleDismiss = () => {
    setUpdateAvailable(false);
  };

  if (!updateAvailable) {
    return null;
  }

  return (
    <Snackbar
      open={updateAvailable}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ mt: 8 }} // Offset for AppBar
    >
      <Alert
        severity="info"
        variant="filled"
        action={
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              color="inherit"
              size="small"
              onClick={handleUpdate}
              disabled={updating}
              startIcon={updating ? <Refresh sx={{ animation: 'spin 1s linear infinite' }} /> : <Update />}
              sx={{
                '@keyframes spin': {
                  '0%': {
                    transform: 'rotate(0deg)',
                  },
                  '100%': {
                    transform: 'rotate(360deg)',
                  },
                },
              }}
            >
              {updating ? 'Updating...' : 'Update'}
            </Button>
            <Button
              color="inherit"
              size="small"
              onClick={handleDismiss}
              disabled={updating}
            >
              Later
            </Button>
          </Box>
        }
        sx={{ width: '100%' }}
      >
        <Typography variant="body2">
          <strong>New version available!</strong>
          <br />
          Update now to get the latest features and improvements.
        </Typography>
      </Alert>
    </Snackbar>
  );
};

export default UpdateNotification;